import { useEffect, useState } from "react";
import styles from "./thumb.module.scss";
import { SkeletonBase } from "../../addons/skeleton/Skeleton";

const baseThumbProps = {
  width: "",
  height: "",
  isRound: false,
  roundSize: 8,
  className: "",
  isCircle: false,
  customStyle: {},
};

// 이미지 썸네일 컴포넌트
// 로딩 진행 중 -> 스켈레톤 이미지 노출, 에러 발생 시 기본 이미지 (회색 로고) 노출
const Thumbnail = ({
  thumbnailProps,
  imgProps,
  showSkeleton = true,
}: {
  thumbnailProps?: {
    width?: string;
    height?: string;
    className?: string;
    isRound?: boolean;
    roundSize?: 8 | 12;
    isCircle?: boolean;
    customStyle?: { [key: string]: any };
  };
  imgProps: { [key: string]: any };
  showSkeleton?: boolean;
}) => {
  const { className, ...thumbStyle } = { ...baseThumbProps, ...thumbnailProps };
  const {
    customStyle: thumbCustomStyle,
    isRound: thumbIsRound,
    roundSize: thumbRoundSize,
    isCircle: thumbIsCircle,
    ...thumbDefaultStyle
  } = thumbStyle;

  const [src, setSrc] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (imgProps?.src) {
      setIsLoaded(false);
      setSrc(imgProps.src);
    }
  }, [imgProps?.src]);

  return (
    <>
      <div
        className={`${styles["thumb"]} ${thumbIsRound && !thumbIsCircle ? styles["is-round-" + thumbRoundSize] : ""} ${thumbIsCircle ? styles["is-circle"] : ""} ${className || ""}`}
        style={{ ...thumbDefaultStyle, ...thumbCustomStyle }}
      >
        {src && (
          <img
            key={src}
            alt="images"
            {...imgProps}
            onError={(e) => {
              if (imgProps.onError) {
                imgProps.onError(e);
              }
              setSrc("");
            }}
            onLoad={(e) => {
              if (imgProps.onLoad) {
                imgProps.onLoad(e);
              }
              const target = e.target as HTMLImageElement;
              if (target.naturalWidth === 0 || target.naturalHeight === 0) {
                //error
                setSrc("");
              }
              setIsLoaded(true);
            }}
            style={{
              opacity: isLoaded ? 1 : 0,
            }}
            loading="lazy"
          />
        )}
        {!isLoaded && src && showSkeleton && <SkeletonBase width={"100%"} height={"100%"} />}
      </div>
    </>
  );
};

export default Thumbnail;
